import { GKSelect, GKTextField, Grid2, MenuItem } from "components";
import { useEffect } from "react";
import { Controller, useFieldArray, useFormContext } from "react-hook-form";
import { BANK_ACCOUNT_TYPES } from "utils/constants";

const InvestorBankDetails = () => {
  const form = useFormContext();

  const { fields, append } = useFieldArray({
    control: form.control,
    name: "clientCreation.bankAccounts",
  });

  useEffect(() => {
    if (fields.length === 0) {
      append({
        name: "",
        accountNum: "",
        confirmAccountNum: "",
        type: "",
        ifsc: "",
      });
    }
  }, []);

  return (
    <Grid2 container size={12} spacing={2}>
      {fields.map((row, index) => (
        <Grid2 container size={12} spacing={2} key={row.id}>
          <Grid2 size={{ xs: 12, md: 6 }}>
            <Controller
              name={`clientCreation.bankAccounts.${index}.name`}
              control={form.control}
              rules={{
                required: {
                  value: true,
                  message: "Please enter account holder name",
                },
              }}
              render={({ field, fieldState: { error } }) => (
                <GKTextField
                  {...field}
                  requiredField
                  inputLabel="Bank Account Name"
                  error={!!error}
                  helperText={error?.message}
                />
              )}
            />
          </Grid2>

          <Grid2 size={{ xs: 12, md: 6 }}>
            <Controller
              name={`clientCreation.bankAccounts.${index}.type`}
              control={form.control}
              rules={{
                required: {
                  value: true,
                  message: "Please select account type",
                },
              }}
              render={({ field, fieldState: { error } }) => (
                <GKSelect
                  {...field}
                  requiredField
                  inputLabel="Bank Account Type"
                  error={!!error}
                  helperText={error?.message}
                  MenuProps={{ disableScrollLock: true }}
                >
                  <MenuItem style={{ display: "none" }} value="">
                    Select Account Type
                  </MenuItem>
                  {BANK_ACCOUNT_TYPES?.map((dataItem) => (
                    <MenuItem value={dataItem?.value} key={dataItem?.value}>
                      {dataItem?.name}
                    </MenuItem>
                  ))}
                </GKSelect>
              )}
            />
          </Grid2>

          <Grid2 size={{ xs: 12, md: 6 }}>
            <Controller
              name={`clientCreation.bankAccounts.${index}.accountNum`}
              control={form.control}
              rules={{
                required: {
                  value: true,
                  message: "Please enter account number",
                },
              }}
              render={({ field, fieldState: { error } }) => (
                <GKTextField
                  {...field}
                  requiredField
                  inputLabel="Bank Account Number"
                  error={!!error}
                  helperText={error?.message}
                />
              )}
            />
          </Grid2>

          <Grid2 size={{ xs: 12, md: 6 }}>
            <Controller
              name={`clientCreation.bankAccounts.${index}.confirmAccountNum`}
              control={form.control}
              rules={{
                required: {
                  value: true,
                  message: "Please confirm account number",
                },
                validate: (val) =>
                  val ===
                    form.getValues(
                      `clientCreation.bankAccounts.${index}.accountNum`,
                    ) || "Account numbers do not match",
              }}
              render={({ field, fieldState: { error } }) => (
                <GKTextField
                  {...field}
                  requiredField
                  inputLabel="Confirm Bank Account Number"
                  error={!!error}
                  helperText={error?.message}
                />
              )}
            />
          </Grid2>

          <Grid2 size={{ xs: 12, md: 6 }}>
            <Controller
              name={`clientCreation.bankAccounts.${index}.ifsc`}
              control={form.control}
              rules={{
                required: { value: true, message: "Please enter IFSC code" },
              }}
              render={({ field, fieldState: { error } }) => (
                <GKTextField
                  {...field}
                  requiredField
                  inputLabel="IFSC Code"
                  error={!!error}
                  helperText={error?.message}
                />
              )}
            />
          </Grid2>
        </Grid2>
      ))}
    </Grid2>
  );
};

export default InvestorBankDetails;
